import { baseProductQuery } from '~/gql/pdp.gql'

export const useProductStore = defineStore('product', {
  state: () => ({
    baseProducts: {},
    spacerMapping: {
      classics3: ['1-rg_shadow.png', 0],
      sierras: ['1-rg_shadow.png', 0],
      zephyrs: ['1-rg_shadow.png', 0],
      tokas: ['1-rg_shadow.png', 0],
      miras: ['1-rg_shadow.png', 0],
      renegades: ['1-rg_shadow.png', 0],
      tempests: ['1-rg_shadow.png', 0],
      classics3lrk: ['1-c3f_outline.png', 1], // 1- replaced with view angle
      sierraslrk: ['1-sf_outline.png', 1], // 1- replaced with view angle
      miraslrk: ['1-mf_outline.png', 1], // 1- replaced with view angle
      tokaslrk: ['1-sf_outline.png', 1], // 1- replaced with view angle
      renegadeslrk: ['1-rgf_outline.png', 1], // 1- replaced with view angle
      tempestslrk: ['1-rgf_outline.png', 1], // 1- replaced with view angle
      revolts: ['Tspacer-rglrk.png', 0],
      revoltparts: ['Tspacer-rglrk.png', 0],
      snipers: ['Tspacer-rglrk.png', 0],
      snipersparts: ['Tspacer-rglrk.png', 0],
      vanguards: ['Tspacer-rglrk.png', 0],
      vanguardsparts: ['Tspacer-rglrk.png', 0],
      ullrs: ['Tspacer-rglrk.png', 0],
      ullrsparts: ['Tspacer-rglrk.png', 0],
      vulcans: ['1-rg_shadow.png', 0],
      vulcanslrk: ['1-vcf_outline-tf.png', 1], // 1- replaced with view angle
      vulcansck: ['1-vcb_outline.png', 1], // 1- replaced with view angle']
      velans: ['1-rg_shadow.png', 0],
      velanslrk: ['1-vef_outline-tf.png', 1], // 1- replaced with view angle
      velansck: ['1-veb_outline.png', 1], // 1- replaced with view angle
      airas: ['1-rg_shadow.png', 0],
      airaslrk: ['1-af_outline-tf.png', 1], // 1- replaced with view angle
      airasck: ['1-ab_outline.png', 1], // 1- replaced with view angle
      pacebreakerslrk: ['Tspacer-pblrk.png', 1],
      pacebreakersesk: ['Tspacer-pbesk.png', 1],
    },
  }),

  getters: {
    spacer: (state) => {
      return (sku) => {
        if (sku === 'classics' || sku === 'classics2') sku = 'classics3'
        const imgAndOpacity = state.spacerMapping[sku] || []
        if (imgAndOpacity.length)
          return { img: imgAndOpacity[0], opacity: imgAndOpacity[1] }
        return { img: '1-rg_shadow.png', opacity: 0 }
      }
    },

    normaliseSKUForFacebook: () => (sku) => {
      const invalidParts = [
        'c2e',
        'c3e',
        'rge',
        'pe',
        'se',
        're',
        've',
        'me',
        'i',
        's',
        'e',
        'lre',
        'po',
        'ge',
        'vce',
        'vee',
        'es',
      ]

      sku = (sku || '')
        .split('-')
        .filter(
          (part) =>
            !invalidParts.some((validPart) => part.startsWith(`${validPart}_`))
        )
        .join('-')

      sku = sku
        .replace(/[A-z3]{1,2}(i|es)_[A-z0-9]+/g, '')
        .replace(/-+/g, '-')
        .replace(/-$/g, '')

      return sku
    },

    icon: (state) => {
      return (sku) => {
        let icon = state.baseProducts[sku]?.icon
        icon = icon.split('sgi-')[1]
        icon = icon.replace(/(-[tzf]f)$/, '')
        if (icon === 'classics2') icon = 'classics3'
        return icon
      }
    },

    productName: (state) => {
      return (sku) => {
        return state.baseProducts[sku]?.name
      }
    },
  },

  actions: {
    SET_BASE_PRODUCT_DATA(result) {
      this.baseProducts = Object.fromEntries(
        result.map((product) => [product.sku, product])
      )
    },
    async GET_BASE_PRODUCT_DATA() {
      const { data: response } = await useDatoQuery({ query: baseProductQuery })
      const result = (response.value || {}).allBaseProducts || []
      this.SET_BASE_PRODUCT_DATA(result)
    },
  },
})
